import React from 'react';

import styles from "./PackageDetailsOrder.module.scss";
import packageIcon from "../../constants/images/detailsOrder/selected-package.svg";

const PackageDetailsOrder = ({
                                 selectedPackage,
                                 countPanoramicWindows,
                                 countOrdinaryWindows,
                                 services,
                                 typeCleaning,
                                 countRooms,
                                 countBathrooms,
                                 style,
                                 showTitle
                             }) => {

    return (
        <div
            style={style}
            className={styles.packageDetailsOrder}
        >
            {
                showTitle &&
                <div className={styles.packageDetailsOrder_block}>
                    <img src={packageIcon} alt="selected package icon"/>
                    <p className={styles.subtitle}>Обрані послуги</p>
                </div>
            }

            <div className={styles.packageDetailsOrder_packagesInfo}>
                <div className={styles.packageDetailsOrder_packagesInfo_item}>
                    <p className={styles.subtitle}>Пакет послуг</p>
                    <p className={styles.userInfoPackage}>{selectedPackage}</p>
                </div>
                <div className={styles.packageDetailsOrder_packagesInfo_item}>
                    <p className={styles.subtitle}>{!!typeCleaning ? typeCleaning : 'Миття вікон'}</p>
                    <div>
                        {!!countOrdinaryWindows &&
                            <p className={styles.userInfoPackage}>{countOrdinaryWindows} звичайних вікон</p>}
                        {!!countPanoramicWindows &&
                            <p className={styles.userInfoPackage}>{countPanoramicWindows} панорамне вікно</p>}
                        {!!countRooms && <p className={styles.userInfoPackage}>{countRooms} кімнати</p>}
                        {!!countBathrooms && <p className={styles.userInfoPackage}>{countBathrooms} санвузли</p>}
                    </div>
                </div>
                <div className={styles.packageDetailsOrder_packagesInfo_item}>
                    <p className={styles.subtitle}>Додаткові послуги</p>
                    <div>
                        {
                            services?.map((item, index) =>
                                <p className={styles.userInfoPackage} key={index}>{item.name}</p>)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PackageDetailsOrder;
